module.exports = __webpack_public_path__ + "img/back-arrow.8b94c27c.svg";